module.exports = __webpack_public_path__ + "img/rule-2.edeb7a48.png";